import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import AdditionalArticlesBlockData from '../../../Models/Content/AdditionalArticlesBlockData';
import {MainAdditionalArticles} from "./MainAdditionalArticles";
export default class ArticlePagesBlock extends EpiComponent<AdditionalArticlesBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <MainAdditionalArticles context={this.getContext()} contentData={this.props.data} />;
  }
}